import axios from 'axios';
import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION';
export const GET_SUBSCRIPTION_SUCCESS = 'GET_SUBSCRIPTION_SUCCESS';
export const GET_SUBSCRIPTION_FAILURE = 'GET_SUBSCRIPTION_FAILURE';

// Action Creators
export const getSubscriptionRequest = () => ({
  type: GET_SUBSCRIPTION,
});

export const getSubscriptionSuccess = (users) => ({
  type: GET_SUBSCRIPTION_SUCCESS,
  payload: users,
});

export const getSubscriptionFailure = (error) => ({
  type: GET_SUBSCRIPTION_FAILURE,
  payload: error,
});

// Thunk Function
export const getSubscription = (external, value) => {
  return async (dispatch) => {
    dispatch(getSubscriptionRequest());
    try {
      const response = await getMethodWithToken(
        url?.subscriptionList + '?query_for=' + value
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getSubscriptionSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getSubscriptionFailure(error?.message));
    }
  };
};
